import {
  ADD_CREDIT_CARD_FAILURE,
  ADD_CREDIT_CARD_SUCCESS,
  ADD_WALLET_VALUE_SUCCESS,
  FETCH_CREDIT_CARD_FAILURE,
  FETCH_CREDIT_CARD_SUCCESS,
  FETCH_ME_FAILURE,
  FETCH_ME_SUCCESS,
  FETCH_WALLET_RECORDS_SUCCESS,
  SET_WALLET_BALANCE,
} from '../../actions/user'

const initialState = {
  isAuth: null,
  user: null,
  creditCards: [],
  walletRecords: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CREDIT_CARD_SUCCESS:
      return {
        ...state,
        creditCards: action.creditCards,
      }
    case FETCH_CREDIT_CARD_FAILURE:
      return {
        ...state,
        creditCards: [],
      }
    case ADD_CREDIT_CARD_SUCCESS:
      return {
        ...state,
        creditCards: [...state.creditCards, action.creditCard],
      }
    case ADD_CREDIT_CARD_FAILURE:
      return {
        ...state,
      }
    case FETCH_WALLET_RECORDS_SUCCESS:
      if (action.offset === 0) {
        return {
          ...state,
          walletRecords: action.walletRecords,
        }
      }
      return {
        ...state,
        walletRecords: [...state.walletRecords, ...action.walletRecords],
      }
    case FETCH_ME_SUCCESS:
      return {
        ...state,
        isAuth: true,
        user: action.user,
      }
    case ADD_WALLET_VALUE_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          wallet_balance: action.walletBalance,
        },
      }
    case SET_WALLET_BALANCE:
      return {
        ...state,
        user: {
          ...state.user,
          wallet_balance: action.walletBalance,
        },
      }
    case FETCH_ME_FAILURE:
      return {
        ...state,
        isAuth: false,
        user: null,
      }
    default:
      return state
  }
}

export const getIsAuth = (state) => {
  return state.user.isAuth
}

export const getUser = (state) => {
  return state.user.user
}

export const getCreditCards = (state) => {
  return state.user.creditCards
}

export const getWalletRecords = (state) => {
  return state.user.walletRecords
}
